import React from "react";
import { REVIEWS } from "../marketingData";

const ReviewsSection = () => (
  <section className="reviews-section" id="reviews">
    <div className="reviews-header reveal">
      <span className="section-eyebrow">Real sellers, real results</span>
      <h2 className="section-h2">
        They switched.
        <br />
        <em>See what happened.</em>
      </h2>
    </div>
    <div className="reviews-grid">
      {REVIEWS.map((review, index) => (
        <div className={`review-card reveal stagger-${index + 1}`} key={review.initials}>
          <div className="review-shine" />
          <div className="review-stars">★★★★★</div>
          <div className="review-text">{review.text}</div>
          <div className="review-transform">{review.transform}</div>
          <div className="review-author">
            <div className="avatar">{review.initials}</div>
            <div>
              <div className="author-name">{review.name}</div>
              <div className="author-role">{review.role}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default ReviewsSection;
